import { PreferCORS, CrossOrigin } from '../Def';

const parseCORS = (cors?: PreferCORS): CrossOrigin => {
    const crossOriginMap = new Map<PreferCORS | undefined, CrossOrigin>([
        [undefined, 'anonymous'],
        [true, 'anonymous'],
        [false, undefined],
        ['anonymous', 'anonymous'],
        ['use-credentials', 'use-credentials'],
    ]);

    if (crossOriginMap.has(cors)) {
        return crossOriginMap.get(cors);
    }

    return 'anonymous';
};

export { parseCORS };
